import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

import '../css/HeroProducts.css';

class HeroProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      sectionTitle: {
        "zh": "探索 Nexuni 的 AI 機器人與自動化方案",
        "en": "Explore Nexuni's AI Robots & Automation",
        "ja": "Nexuni の AI ロボット＆自動化を探る"
      },
      viewAllText: {
        "zh": "查看所有產品與方案",
        "en": "View All Products & Solutions",
        "ja": "すべての製品とソリューションを見る"
      },
      products: [
        {
          image: "/assets/product/nxbot/collie.png",
          route: "/tech/collie",
          name: {
            "zh": "自主巡邏機器人",
            "en": "AI Patrol Robot Dog",
            "ja": "AI巡回ロボット犬"
          }
        },
        {
          image: "/assets/product/nxbot/welding_robot_logo.png",
          route: "/tech/beaver",
          name: {
            "zh": "智慧焊接機器人",
            "en": "Intelligent Welding Robot",
            "ja": "スマート溶接ロボット"
          }
        },
        {
          image: "/assets/product/nxa/pms.jpg",
          route: "/tech/pms100",
          name: {
            "zh": "AI 智慧停車",
            "en": "AI Smart Parking",
            "ja": "AIスマート駐車"
          }
        },
        {
          image: "/assets/product/nxa/vs.png",
          route: "/tech/vs100",
          name: {
            "zh": "AI 影像安防",
            "en": "AI Video Security",
            "ja": "AI映像セキュリティ"
          }
        }
      ]
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {
    const lang = this.state.lang;

    return (
      <div className="hero-products">
        <div className="hero-products-inner">
          <Fade duration={800} delay={200}>
            <h2 className="hero-products-title">{this.state.sectionTitle[lang]}</h2>
          </Fade>
          <div className="hero-products-grid">
            {this.state.products.map((product, index) => (
              <Fade duration={800} delay={300 + index * 150} key={index}>
                <div
                  className="hero-product-card"
                  onClick={() => this.props.navigate(product.route)}
                >
                  <div className="hero-product-img-wrap">
                    <img src={product.image} alt={product.name[lang]} />
                  </div>
                  <p className="hero-product-name">{product.name[lang]}</p>
                </div>
              </Fade>
            ))}
          </div>
          <Fade duration={800} delay={900}>
            <div className="hero-products-cta">
              <button className="hero-products-btn" onClick={() => this.props.navigate('/solutions')}>
                {this.state.viewAllText[lang]} &rarr;
              </button>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

export default HeroProducts;
